import React from 'react';

const ActionButtonGroup = ({ children }) => (
  <div className="ws-ui-action-button-group">{children}</div>
);

export default ActionButtonGroup;
